import { NgModule } from '@angular/core';
import { ioteqSplashScreenService } from '@tools/services/splash-screen/splash-screen.service';

@NgModule({
    providers: [
        ioteqSplashScreenService
    ]
})
export class ioteqSplashScreenModule
{
    /**
     * Constructor
     */
    constructor(private _ioteqSplashScreenService: ioteqSplashScreenService)
    {
    }
}
